import * as React from 'react';

const SvgTrialStar = (props) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.77655 4.81152C5.5628 6.26797 4.88563 7.61663 3.8451 8.65795C2.80451 9.69901 1.45618 10.3772 0 10.5918C1.45618 10.805 2.80484 11.4824 3.84537 12.523C4.88596 13.5638 5.56337 14.9122 5.77662 16.3684C5.99114 14.9122 6.66933 13.5638 7.71045 12.5233C8.75177 11.483 10.1004 10.8056 11.5569 10.5918C10.1004 10.3768 8.75177 9.69861 7.71072 8.65782C6.66993 7.61676 5.99173 6.2681 5.77669 4.81166L5.77655 4.81152Z"
      fill="white"
    />
    <path
      d="M11.5567 0.220703C11.4554 0.904859 11.1365 1.53833 10.6475 2.02737C10.1585 2.5164 9.52498 2.83532 8.84082 2.93662C9.52498 3.0382 10.1584 3.35688 10.6475 3.84587C11.1365 4.33513 11.4554 4.96838 11.5567 5.65253C11.6578 4.96944 11.9754 4.33695 12.4631 3.84799C12.9506 3.35898 13.5825 3.03951 14.2654 2.93668C13.5825 2.83382 12.9506 2.51436 12.4631 2.02538C11.9754 1.53637 11.6578 0.903933 11.5567 0.220835V0.220703Z"
      fill="white"
    />
    <path
      d="M1.03387 4.23683C1.07316 3.97605 1.19515 3.7349 1.38202 3.54884C1.56862 3.36275 1.81029 3.24153 2.07133 3.20302C1.80977 3.16451 1.56785 3.04277 1.38096 2.8559C1.19409 2.66904 1.07235 2.42711 1.03384 2.16553C0.996625 2.42683 0.875667 2.66927 0.689317 2.85617C0.502967 3.04329 0.261303 3.16503 0 3.20302C0.260787 3.24102 0.502187 3.36223 0.688259 3.54859C0.874609 3.73468 0.995824 3.97608 1.03382 4.23685L1.03387 4.23683Z"
      fill="white"
    />
    <path
      d="M16.6739 9.55435C16.4131 9.51713 16.1711 9.39617 15.9848 9.20956C15.7985 9.02321 15.6775 8.78155 15.64 8.52051C15.6013 8.78155 15.4795 9.02322 15.2926 9.2093C15.1058 9.39565 14.8636 9.5166 14.6025 9.55434C14.8638 9.59362 15.1055 9.71536 15.2924 9.90223C15.479 10.0888 15.601 10.3308 15.64 10.5918C15.6778 10.3308 15.799 10.0888 15.9851 9.90196C16.1714 9.7151 16.4128 9.5931 16.6738 9.55433L16.6739 9.55435Z"
      fill="white"
    />
  </svg>
);

export default SvgTrialStar;
